<template>
  <div>
    <transition-group tag="div" name="fade">
      <div v-for="record in records" :key="record.id" class="record">
        <record-item
          @delete-record-item="deleteRecord"
          @restore-record-item="restoreRecord"
          @edit-record-notes="editRecordNotes"
          @clicked-record-item="clickedRecordHandler"
          @mark-record-relevance-item="markRecord"
          :record="record"
          :read-only="readOnly"
          :selectedRecords="selectedRecords"
          :showSelectIndex="showSelectIndex"
          :isChoosingMode="isChoosingMode"
        />
      </div>
    </transition-group>
    <div>
      <confirm-modal-2
        v-if="recordPendingDeletion"
        @cancel="recordPendingDeletion = null"
        @ok="confirmDeleteRecord"
      >
        <template slot="content">
          <p>{{ $t('records.delete_confirmation') }}</p>
        </template>
        <template slot="ok">{{ $t('delete') }}</template>
      </confirm-modal-2>
      <modal
        v-if="recordNotesBeingEdited"
        :show="!!recordNotesBeingEdited"
        @ok="saveRecordComment"
        @hide="closeCommentModal"
        :okBtnText="$t('save')"
        :disableOkBtn="disableCommentModalBtn"
      >
        <template slot="body">
          <div class="edit-record-notes form-group">
            <div>
              <v-textarea
                name="record-title" 
                rows="8" 
                cols="80" 
                class="form-control"
                counter="100"
                v-model="recordTitleEdited"
              />
              <textarea v-if="recordHasDescriptionField" name="record-description" rows="8" cols="80" class="form-control"
               v-model="recordDescriptionEdited"
              ></textarea>
              <textarea v-if="recordHasComment" name="record-description" rows="8" cols="80" class="form-control"
               v-model="recordCommentEdited"
              ></textarea>
            </div>
            <div
              class="loading-indicator"
              v-show="recordNotesSaveInProgress">
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
// Records list component
// Load and render a list of vods for a marker
import RecordItem from './RecordItem.vue'
import ConfirmModal2 from '../../generic/ConfirmModal2.vue'
import Modal from '../../generic/Modal.vue'
import debounce from 'lodash.debounce'
import RecordRepository from '../../../repositories/RecordRepository.js'
import events from '../../../services/events'

export default {
  components: {
    ConfirmModal2,
    RecordItem,
    Modal
  },
  props: [
    'records', 'marker', 'records_type', 'readOnly',
    'selectedRecords', 'showSelectIndex', 'isChoosingMode'
  ],
  data () {
    return {
      recordPendingDeletion: null,
      // in past they served record notes now they serve record comment
      recordNotesBeingEdited: null,
      recordNotesSaveInProgress: false,
      recordCommentEdited: '',
      recordTitleEdited: '',
      recordDescriptionEdited: '',
      recordConsumerName: '',
      recordHasComment: false, // for support old version LNG consumer app used comment
      recordHasDescriptionField: false
    }
  },
  mounted () {
    this.recordNotesUpdateHandler = debounce(this.saveRecordNotes, 1000)
  },
  methods: {
    clickedRecordHandler (record) {
      this.$emit('clicked-record', record)
    },
    // propagate the thumbs up/down event upwards for the parent component to catch
    markRecord (record, relevance) {
      this.$emit('mark-record-relevance', record, relevance, record.record_type)
    },
    deleteRecord (record) {
      this.recordPendingDeletion = record
    },
    restoreRecord (record) {
      this.$emit('restore-record', record, record.record_type)
    },
    confirmDeleteRecord () {
      this.$emit('delete-record', this.recordPendingDeletion, this.recordPendingDeletion.record_type)
      this.recordPendingDeletion = null
    },
    editRecordNotes (record) {
      this.recordConsumerName = record.consumer
      this.recordNotesBeingEdited = record
      if (record.comment && !record.title) {
        this.recordHasComment = true
      } else if (record.comment && record.title && !record.description) {
        this.recordHasComment = true
      }
      this.recordHasDescriptionField = record.has_description_field
      if (this.recordHasComment && this.recordHasDescriptionField) {
        this.recordHasDescriptionField = false
      }
      this.recordCommentEdited = record.comment
      this.recordTitleEdited = record.title
      this.recordDescriptionEdited = record.description
    },
    saveRecordNotes (record, e) {
      // notes modal became comment modal so this function can be deprecated
      this.recordNotesSaveInProgress = true
      RecordRepository.patchRecordNotes(this.markerId, record, e.target.value)
      .then(() => {
        this.recordNotesSaveInProgress = false
      }, (error) => {
        events.emit('error', error, '', {modal: false})
        this.recordNotesSaveInProgress = false
      })
    },
    saveRecordComment () {
      this.recordNotesSaveInProgress = true
      const newTitle = this.recordTitleEdited
      const newComment = this.recordCommentEdited
      const newDescription = this.recordDescriptionEdited
      const record = this.recordNotesBeingEdited
      RecordRepository.patchRecordComment(this.recordNotesBeingEdited, {
        comment: newComment,
        title: newTitle,
        description: newDescription
      }).then(
        () => {
          this.recordNotesSaveInProgress = false
          this.recordNotesBeingEdited = null
          record.comment = newComment
          record.title = newTitle
          record.description = newDescription
        },
        (error) => {
          events.emit('error', error, '', {modal: false})
          this.recordNotesSaveInProgress = false
        }
      )
    },
    closeCommentModal () {
      if (!this.recordNotesSaveInProgress) this.recordNotesBeingEdited = null
    }
  },
  computed: {
    markerId () {
      return this.marker && this.marker.id
    },
    disableCommentModalBtn () {
      if (this.recordHasDescriptionField) {
        if (this.recordNotesBeingEdited) return !this.recordTitleEdited || !this.recordDescriptionEdited || (this.recordTitleEdited.length > 100)
        else return false
      } else {
        if (this.recordNotesBeingEdited) return !this.recordTitleEdited || (this.recordTitleEdited.length > 100)
        else return false
      }
    }
  }
}
</script>
